'use client';
import { jsx, Fragment } from 'react/jsx-runtime';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { Loader } from '../Loader/Loader.js';
import { COLUMN_AUTO_SIZE } from './Table.constants.js';
import { useTable } from './TableProvider.js';
import { Td } from './Td.js';
import { Tr } from './Tr.js';

const TableLoader = /*#__PURE__*/withTitan(({
  testId = 'tableLoader'
}) => {
  const {
    instance,
    loaderHeight = 20
  } = useTable();
  const rows = instance.getRowModel().rows;
  const pageSize = instance.getState().pagination.pageSize;
  const rowLength = Math.min(rows.length || pageSize, pageSize);
  return jsx(Fragment, {
    children: Array(rowLength).fill(0).map((_, index) => jsx(Tr, {
      "data-test-id": `${testId}Row`,
      children: instance.getAllColumns().map(column => jsx(Td, {
        "aria-hidden": "true",
        hasRowSpan: false,
        width: column.getSize() !== COLUMN_AUTO_SIZE ? column.getSize() : undefined,
        children: jsx(Loader, {
          height: loaderHeight,
          variant: "skeleton"
        })
      }, column.id))
    }, `loadingRow${index}`))
  });
}, {
  name: 'TableLoader'
});

export { TableLoader };
//# sourceMappingURL=TableLoader.js.map
